<script>
import { defineNuxtComponent } from "#imports";
export default defineNuxtComponent({
  props: {
    blocks: {
      type: Array,
      default: () => []
    },
    placeholders: {
      type: Array,
      default: () => []
    },
    content: {
      type: Array,
      default: () => []
    },
    cfgs: {
      type: Object,
      default: () => {
      }
    },
    extras: {
      type: Object,
      default: () => ({})
    },
    values: {
      type: Object,
      default: () => ({})
    },
    externalData: {
      type: Object,
      default: () => ({})
    }
  }
});
</script>
